import React from 'react'
import { PageSkeleton } from '../Section/PageSkeleton'
import { SectionHeading } from '../Section'
import { Box } from '@material-ui/core'
import { LogoInline } from '../LogoInline'
import DateTime from 'luxon/src/datetime'
import { Content } from './TermsContent'
import { COMPANY, COMPANY_ADDRESS } from '../../company'

/** When the programme runs. The only place these two dates are written. */
const STARTS_AT = DateTime.local(2026, 10, 1).setLocale('pl')
const ENDS_AT = DateTime.local(2026, 12, 31).setLocale('pl')

const asDate = date => date.toLocaleString(DateTime.DATE_FULL)

export const TermsOfUseTrainerProgram = () => {
  const lastUpdatedAt = DateTime.local(2026, 8, 26).setLocale('pl')

  return (
    <PageSkeleton>
      <SectionHeading>
        Regulamin akcji testowej Trenażer <LogoInline />
      </SectionHeading>
      <Box display="flex" justifyContent="center">
        <Content>
          <ol>
            <li>POSTANOWIENIA OGÓLNE</li>

            <ol>
              <li>
                Definicje:
                <ul>
                  <li>
                    <strong>Regulamin</strong> - niniejszy regulamin akcji
                    testowej;
                  </li>

                  <li>
                    <strong>Organizator</strong> – {COMPANY.name}, przedsiębiorca
                    prowadzący jednoosobową działalność gospodarczą wpisaną do Centralnej Ewidencji i Informacji o Działalności Gospodarczej, NIP{' '}
                    {COMPANY.nipNumber}, adres siedziby {COMPANY_ADDRESS},{' '}
                    {COMPANY.country}, adres e-mail: {COMPANY.email};
                  </li>

                  <li>
                    <strong>Aplikacja</strong> – aplikacja mobilna CEL-PAL, do
                    której stosuje się Regulamin Aplikacji Mobilnej dostępny pod
                    adresem celpal.net/regulamin-aplikacji-mobilnej;
                  </li>

                  <li>
                    <strong>Akcja</strong> – akcja testowa funkcji Trenażer,
                    prowadzona na zasadach określonych w Regulaminie;
                  </li>

                  <li>
                    <strong>Trenażer</strong> – funkcja Aplikacji polegająca na
                    automatycznym rozpoznawaniu przestrzelin na zdjęciu tarczy
                    strzeleckiej i wyliczaniu wyniku, udostępniana w wersji
                    testowej;
                  </li>

                  <li>
                    <strong>Uczestnik</strong> – osoba fizyczna, która
                    przystąpiła do Akcji na zasadach określonych w rozdziale II;
                  </li>

                  <li>
                    <strong>Materiał</strong> – zdjęcie tarczy strzeleckiej wraz
                    z informacją o typie tarczy i użytym kalibrze oraz z
                    zatwierdzonymi lub poprawionymi przez Uczestnika położeniami
                    przestrzelin.
                  </li>
                </ul>
              </li>

              <li>
                Akcja trwa od dnia {asDate(STARTS_AT)} r. do dnia{' '}
                {asDate(ENDS_AT)} r. Organizator może przedłużyć czas trwania
                Akcji, informując o tym w Aplikacji z co najmniej siedmiodniowym
                wyprzedzeniem. Skrócenie czasu trwania Akcji jest
                niedopuszczalne z wyjątkiem przypadków określonych w pkt 7.2.
              </li>

              <li>
                Celem Akcji jest zebranie materiału pozwalającego na rozwój i
                przetestowanie Trenażera. Akcja nie jest grą losową ani zakładem
                wzajemnym w rozumieniu ustawy o grach hazardowych.
              </li>

              <li>
                Udział w Akcji jest dobrowolny i nieodpłatny. Odmowa udziału nie
                wpływa na możliwość korzystania z pozostałych funkcjonalności
                Aplikacji, w szczególności z wpisu do książki pobytu na
                strzelnicy.
              </li>
            </ol>

            <li>UCZESTNICY I PRZYSTĄPIENIE DO AKCJI</li>

            <ol>
              <li>
                Uczestnikiem Akcji może być wyłącznie osoba fizyczna, która
                ukończyła 18 lat, posiada pełną zdolność do czynności prawnych i
                posiada aktywne konto w Aplikacji.
              </li>

              <li>
                Przystąpienie do Akcji następuje przez zaznaczenie w Aplikacji
                dwóch odrębnych oświadczeń:
                <ul>
                  <li>akceptacji Regulaminu;</li>
                  <li>
                    zgody na wykorzystanie przesyłanych zdjęć tarcz do
                    trenowania systemu rozpoznawania przestrzelin.
                  </li>
                </ul>
              </li>

              <li>
                Zgoda, o której mowa w pkt 2.2 tiret drugie, jest zgodą w
                rozumieniu art. 6 ust. 1 lit. a) RODO. Uczestnik może ją wycofać
                w każdej chwili, kontaktując się z Organizatorem pod adresem
                kontakt@celpal.net. Wycofanie zgody jest równoznaczne z
                rezygnacją z udziału w Akcji i nie wpływa na konto Uczestnika
                ani na możliwość korzystania z pozostałych funkcjonalności
                Aplikacji.
              </li>

              <li>
                W okresie trwania Akcji korzystanie z Trenażera wymaga udziału w
                Akcji, ponieważ jego wyłącznym celem jest zebranie materiału do
                rozwoju tej funkcji. Po udostępnieniu Trenażera wszystkim
                użytkownikom Aplikacji korzystanie z niego nie będzie
                uzależnione od zgody, o której mowa w pkt 2.2 tiret drugie.
              </li>

              <li>
                Uczestnik może zrezygnować z udziału w Akcji w każdej chwili,
                bez podania przyczyny i bez żadnych konsekwencji.
              </li>
            </ol>

            <li>PRZEBIEG AKCJI</li>

            <ol>
              <li>
                Udział w Akcji polega na przesyłaniu Organizatorowi Materiałów
                za pośrednictwem Aplikacji. Uczestnik decyduje samodzielnie, ile
                Materiałów prześle; Regulamin nie przewiduje żadnej minimalnej
                liczby.
              </li>

              <li>
                W celu przesłania Materiału Uczestnik zakłada w Aplikacji
                trening, wskazując rodzaj tarczy i użyty kaliber, wykonuje
                zdjęcie tarczy zgodnie ze wskazówkami wyświetlanymi w Aplikacji,
                a następnie zatwierdza zaproponowane przez Trenażer oznaczenia
                przestrzelin, poprawiając błędne i dodając pominięte.
              </li>

              <li>
                Uczestnik oświadcza, że przysługują mu prawa do przesłanego
                Materiału oraz że Materiał nie przedstawia wizerunku osób
                fizycznych, nie zawiera danych osobowych osób trzecich ani
                treści bezprawnych.
              </li>

              <li>
                Zasady korzystania przez Organizatora z przesłanych Materiałów,
                w tym zakres udzielanej licencji oraz prawo Organizatora do
                odmowy przyjęcia lub usunięcia Materiału, określa Regulamin
                Aplikacji Mobilnej. Organizator usuwa z przesyłanych plików
                metadane zapisane przez urządzenie rejestrujące, w tym
                informacje o lokalizacji.
              </li>

              <li>
                Trenażer jest udostępniany w wersji testowej. Organizator nie
                gwarantuje poprawności wyliczonego wyniku ani poprawności
                rozpoznania przestrzelin, a wynik wyliczony przez Trenażer nie
                stanowi podstawy do jakichkolwiek rozstrzygnięć sportowych.
              </li>
            </ol>

            <li>CO OTRZYMUJE UCZESTNIK</li>

            <ol>
              <li>
                Uczestnik otrzymuje dostęp do Trenażera przed udostępnieniem tej
                funkcji pozostałym użytkownikom Aplikacji oraz możliwość
                zgłaszania Organizatorowi uwag na temat jej działania.
              </li>

              <li>
                Udział w Akcji nie wiąże się z jakimkolwiek świadczeniem
                pieniężnym ani rzeczowym na rzecz Uczestnika. Uczestnik nie
                ponosi też z tego tytułu żadnych kosztów.
              </li>

              <li>
                Organizator może w czasie trwania Akcji wprowadzić dodatkowe
                świadczenia dla Uczestników, ogłaszając ich warunki w Aplikacji.
                Wprowadzenie takich świadczeń nie zmienia pozostałych zasad
                udziału określonych w Regulaminie i nie jest warunkiem dalszego
                uczestnictwa.
              </li>

              <li>
                Po zakończeniu Akcji Organizator nie gwarantuje, że Trenażer
                pozostanie dostępny nieodpłatnie ani że pozostanie dostępny w
                ogóle. O zmianie zasad korzystania z Trenażera Organizator
                poinformuje w Aplikacji z co najmniej trzydziestodniowym
                wyprzedzeniem.
              </li>
            </ol>

            <li>POSTĘPOWANIE REKLAMACYJNE</li>

            <ol>
              <li>
                Reklamacje dotyczące Akcji można składać na adres e-mail
                kontakt@celpal.net albo pisemnie na adres siedziby Organizatora,
                w terminie 30 dni od dnia zakończenia Akcji.
              </li>

              <li>
                Reklamacja powinna zawierać oznaczenie Uczestnika w sposób
                umożliwiający jego identyfikację oraz opis okoliczności
                stanowiących podstawę reklamacji.
              </li>

              <li>
                Organizator rozpatruje reklamację w terminie 14 dni od dnia jej
                otrzymania i informuje Uczestnika o rozstrzygnięciu w sposób, w
                jaki reklamacja została złożona.
              </li>

              <li>
                Postępowanie reklamacyjne nie wyłącza uprawnień Uczestnika
                wynikających z powszechnie obowiązujących przepisów prawa, w tym
                możliwości dochodzenia roszczeń przed sądem.
              </li>
            </ol>

            <li>DANE OSOBOWE</li>

            <ol>
              <li>
                Administratorem danych osobowych Uczestników jest Organizator.
                Zasady przetwarzania danych osobowych określa Polityka
                Prywatności dostępna pod adresem
                celpal.net/mobilna-polityka-prywatnosci.
              </li>

              <li>
                Dane osobowe Uczestników przetwarzane są w celu przeprowadzenia
                Akcji i rozpatrzenia ewentualnych reklamacji, na podstawie art.
                6 ust. 1 lit. b) i f) RODO, a przesłane Materiały – w celu
                rozwoju Trenażera, na podstawie zgody, o której mowa w pkt 2.2.
              </li>

              <li>
                Wycofanie zgody powoduje zaprzestanie dalszego wykorzystywania
                przesłanych Materiałów oraz ich usunięcie. Uczestnik przyjmuje
                do wiadomości, że nie jest technicznie możliwe cofnięcie skutków
                przeprowadzonego już procesu trenowania, a modele wytrenowane
                przed wycofaniem zgody nie pozwalają na odtworzenie ani
                wyodrębnienie pojedynczego Materiału.
              </li>
            </ol>

            <li>POSTANOWIENIA KOŃCOWE</li>

            <ol>
              <li>
                Organizator może zmienić Regulamin wyłącznie z ważnych przyczyn,
                w szczególności w razie zmiany przepisów prawa, i wyłącznie w
                zakresie, w jakim zmiana nie pogarsza sytuacji Uczestników. O
                zmianie Organizator informuje w Aplikacji z co najmniej
                siedmiodniowym wyprzedzeniem.
              </li>

              <li>
                Organizator może zakończyć Akcję przed terminem wyłącznie z
                przyczyn od niego niezależnych, uniemożliwiających jej dalsze
                prowadzenie.
              </li>

              <li>
                Zakończenie Akcji nie wpływa na możliwość korzystania z
                Aplikacji ani na konto Uczestnika.
              </li>

              <li>
                W sprawach nieuregulowanych Regulaminem stosuje się Regulamin
                Aplikacji Mobilnej oraz przepisy prawa polskiego.
              </li>

              <li>
                Ewentualne spory mogące powstać w związku ze stosowaniem
                Regulaminu rozstrzygane będą przez właściwe sądy powszechne.
              </li>

              <li>
                Regulamin niniejszy wchodzi w życie z dniem{' '}
                {asDate(lastUpdatedAt)}.
              </li>
            </ol>
          </ol>
        </Content>
      </Box>
    </PageSkeleton>
  )
}
